import AformItem from '@/components/AformItem';
import regexp from '../rules';
import './index.css';

export default {
  name: 'AfEditor',
  props: {
    id: { type: String, default: () => (`a-f-editor-${Math.random().toString().substring(2)}`) },
    value: { type: Object, default: () => ({}) },
    must: { type: Boolean, default: () => false },
    inline: { type: Boolean, default: () => false },
    cols: { type: Number | String, default: () => 1 },
    gutter: { type: Number | String, default: () => 16 },
    rules: { type: Object, default: () => ({}) },
    config: { type: Object, default: () => ({}) },
    values: { type: Object, default: () => ({}) },
    global: { type: Boolean, default: () => false },
    prompt: { type: Boolean, default: () => false },
    review: { type: Boolean, default: () => false },
    disabled: { type: Boolean, default: () => false },
  },
  data() {
    return {
      form: this.value,
      option: {},
      width: 'auto',
      timeout: null,
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler() {
        this.relate(this.config);
      },
    },
    values: {
      deep: true,
      immediate: true,
      handler() {
        this.relate(this.config);
      },
    },
  },
  computed: {
    data() {
      const data = {};
      Object.keys(this.form).length > 0 && (Object.keys(this.form).forEach(a => {
        if (this.option[a]) {
          const { ...r } = this.option[a];
          const ignore = r.ignore || r.empty || r.blank || r.omit;
          if (!ignore) {
            if (this.form[a] != undefined) {
              if (Array.isArray(this.form[a])) {
                if (r.split && r.split.length > 1) {
                  r.split.forEach((b, c) => data[b] = this.form[a][c]);
                } else if (r.type && (r.type == 'cascader')) {
                  if (this.form[a].pop) data[a] = this.form[a].pop();
                } else data[a] = this.form[a].toString();
              } else data[a] = this.form[a];
            }
          } else data[a] = undefined;
        }
      }));
      const value = {};
      Object.keys(data).length > 0 && (Object.keys(data).forEach(a => (data[a] != undefined && (value[a] = data[a]))));
      return value;
    },
  },
  created() {
    this.relate(this.config);
  },
  mounted() {
    this.resize();
  },
  destroyed() {
    this.revoke();
  },
  methods: {
    input() {
      this.$emit('input', this.form);
    },
    change() {
      this.$emit('change', this.data, this.form, this.option);
    },
    resize() {
      this.$nextTick(() => {
        const items = document.getElementsByClassName(`${this.id}-item`);
        if (items && (items.length > 0)) {
          let width = 0;
          for (let a = 0; a < items.length; a++) {
            const item = items[a].firstChild;
            if (item && (item.clientWidth > width)) width = item.clientWidth;
          }
          this.$nextTick(() => this.width = `${(width + 1)}px`);
        }
      });
    },
    relate(config = {}) {
      const data = {};
      if (this.values) Object.keys(config).forEach(a => {
        const { ...r } = config[a];
        const child = r.children || r.child || r.node || null;
        if (child && Object.keys(child).length > 0) {
          this.relate(child);
        } else {
          const type = (r.type && (r.type != '')) ? r.type.toLowerCase().trim() : '';
          if (this.values[a] != undefined) {
            if (r.multiple || (type == 'cascader' || type == 'checkboxgroup')) {
              if (typeof this.values[a] == 'string') data[a] = this.values[a] ? this.values[a].split(',') : [];
            } else data[a] = `${this.values[a]}`;
          } else {
            if (r.multiple || (type == 'cascader' || type == 'checkboxgroup')) {
              data[a] = [];
            }
            r.default && (data[a] = r.default);
          }
        }
      });
      this.form = { ...data, ...this.value };
      if (this.global) {
        const { formParams = {} } = this.$store.state;
        this.$store.commit('setFormParams', { ...formParams, ...this.form });
      }
    },
    create(a, b) {
      if (!this.config[a]) return;
      const { rule = [], ...r } = this.config[a];
      const type = (r.type && (r.type != '')) ? r.type.toLowerCase().trim() : '';
      const label = r.text || r.label || r.title || r.name || '';
      const width = r.width ? r.width : (`${100 / this.cols}%`);
      const valid = r.type && regexp[r.type] ? [regexp[r.type]] : [];
      const check = (r.must == false || r.required == false) ? null : (this.must || r.must || r.required);
      const range = { min: (r.minlength || r.minLength || r.min), max: (r.maxlength || r.maxLength || r.max) };
      const least = range.min ? [{ min: parseInt(range.min), message: `至少输入${range.min}个字符`, trigger: ['blur'] }] : [];
      const limit = range.max ? [{ max: parseInt(range.max), message: `最多输入${range.max}个字符`, trigger: ['blur', 'change'] }] : [];
      const other = (type == 'number' || type == 'editor') ? rule : [...least, ...limit, ...rule];
      const merge = check ? [{ required: true, message: (`${label}不能为空`) }, ...valid, ...other] : [...valid, ...other];
      const rules = r.disabled || this.disabled ? [] : (r.rules ? [...merge, ...r.rules] : merge);
      const attrs = { name: a, prop: a, labelWidth: this.width, label: (this.review ? (`${label}:`) : label), rules, ...r, data: null };
      const after = r.postfix || r.suffix || r.after || r.extra || r.added || r.unit || null;
      const extra = after && (<span class={['form-item-after', a]}>{typeof after !== 'string' ? after() : after}</span>);
      if (this.inline) {
        const style = { padding: `0 ${this.gutter / 2}px`, width };
        return (
          <div class={['form-item-container', a]}>
            {this.$slots.before}
            {this.$slots.front}
            {this.$slots.left}
            <el-form-item class={[`${this.id}-item`, a]} style={style} {...{ attrs }}>
              {r.labelSlot && (<template slot="label">{r.labelSlot()}</template>)}
              {this.format(r, a)}
              {extra}
            </el-form-item>
            {this.$slots.default}
          </div>
        );
      } else {
        if (r.span) {
          return (
            <el-col key={b} class={a} span={Number(r.span)}>
              <el-form-item class={[`${this.id}-item`, a]} {...{ attrs }}>
                {r.labelSlot && (<template slot="label">{r.labelSlot()}</template>)}
                {this.format(r, a)}
                {extra}
              </el-form-item>
            </el-col>
          );
        } else {
          return (
            <el-col key={b} class={a} style={{ width }}>
              <el-form-item class={[`${this.id}-item`, a]} {...{ attrs }}>
                {r.labelSlot && (<template slot="label">{r.labelSlot()}</template>)}
                {this.format(r, a)}
                {extra}
              </el-form-item>
            </el-col>
          );
        }
      }
    },
    format(a, b) {
      this.option[b] = a;
      const child = a.children || a.child || a.node || null;
      if (child && Object.keys(child).length > 0) {
        return Object.keys(child).map((c, d) => {
          const { ...r } = child[c];
          const space = a.gutter !== undefined ? (a.gutter / 2) : (this.gutter / 4);
          const style = { padding: `0 ${space}px` };
          r.type = r.type ? r.type : a.type;
          const after = r.postfix || r.suffix || r.after || r.extra || r.added || r.unit || null;
          const extra = after && (<span class={['form-item-after', c]}>{typeof after !== 'string' ? after() : after}</span>);
          if (r.span) {
            return (
              <el-col key={d} class={[b, c]} style={style} span={Number(r.span)}>
                {r.labelSlot && (<template slot="label">{r.labelSlot()}</template>)}
                {this.format(r, c)}
                {extra}
              </el-col>
            );
          } else {
            const width = r.width ? r.width : (`${(100 / Object.keys(child).length)}%`);
            return (
              <el-col key={d} class={[b, c]} style={{ width, ...style }}>
                {r.labelSlot && (<template slot="label">{r.labelSlot()}</template>)}
                {this.format(r, c)}
                {extra}
              </el-col>
            );
          }
        });
      } else {
        const attrs = { form: this.form, field: b, ...a };
        if (this.review && (!a.data)) {
          if (a.render) return a.render(this.values);
          return (<div class={['form-value', b]}>{this.form[b]}</div>);
        } else return (<AformItem class={b} on-input={this.input} on-change={this.change} {...{ attrs }} />);
      }
    },
    verify() {
      let success = false;
      this.$refs.form.validate((valid, items) => {
        if (valid) {
          success = true;
        } else if (this.prompt) {
          Object.keys(items).forEach(a => items[a].forEach((b, c) => {
            if (this.timeout) {
              clearTimeout(this.timeout);
              this.timeout = null;
            } else this.timeout = setTimeout(() => {
              this.$message.info(b.message);
              clearTimeout(this.timeout);
              this.timeout = null;
            }, c);
          }));
        }
      });
      return success;
    },
    finish() {
      if (this.verify()) this.$emit('finish', this.data, this.form, this.option);
    },
    submit() {
      if (this.global) {
        const { pageParams } = this.$store.state;
        this.$store.commit('setFormParams', this.data);
        this.$store.commit('setPageParams', { ...pageParams, page: 1 });
      }
      if (this.verify()) this.$emit('submit', this.data, this.form, this.option);
    },
    reject() {
      if (this.verify()) this.$emit('reject', this.data, this.form, this.option);
    },
    repeal() {
      this.$emit('repeal', this.data, this.form, this.option);
    },
    cancel() {
      this.$refs.form && this.$refs.form.resetFields && this.$refs.form.resetFields();
      this.$nextTick(() => {
        this.relate(this.config);
        this.$nextTick(() => {
          if (this.global) {
            const { pageParams } = this.$store.state;
            this.$store.commit('setFormParams', this.data);
            this.$store.commit('setPageParams', { ...pageParams, page: 1 });
          }
          this.$nextTick(() => this.$emit('cancel', this.data, this.form, this.option));
        });
      });
    },
    revoke() {
      this.width = 'auto';
      this.$nextTick(() => {
        if (this.timeout) {
          clearTimeout(this.timeout);
          this.timeout = null;
        }
      });
    },
  },
  render() {
    const {
      width = '100%',
      margin = '0',
      padding = '0',
      size = 'small',
      loading = false,
      finishText = '保存',
      submitText = '提交',
      rejectText = '驳回',
      repealText = '关闭',
      cancelText = '取消',
      action = [],
      ...rest
    } = this.$attrs;
    const style = this.inline ? { margin: `0 -${this.gutter / 2}px` } : {};
    const attrs = { size, rules: this.rules, inline: this.inline, 'label-width': 'auto', 'label-position': this.review ? 'right' : 'top', ...rest };
    const { finish = null, submit = null, reject = null, repeal = null, cancel = null } = this.$listeners;
    return (
      <div class={['a-f-editor', (this.review ? 'review' : null)]} style={{ width, margin, padding }}>
        <el-form ref="form" id={this.id} disabled={this.review || this.disabled} style={style} props={{ model: this.form }} {...{ attrs }}>
          {this.inline ? Object.keys(this.config).map((a, b) => this.config[a] && this.create(a, b)) : (
            <div class="a-f-editor-column">
              <el-row gutter={Number(this.gutter)} class="a-f-editor-rows a-f-editor-main-rows">
                <el-col>{this.$slots.before}</el-col>
                <el-col>{this.$slots.front}</el-col>
                <el-col>{this.$slots.left}</el-col>
                {Object.keys(this.config).map((a, b) => this.config[a] && this.create(a, b))}
                <el-col>{this.$slots.default}</el-col>
              </el-row>
            </div>
          )}
          {((finish || submit || reject || repeal || cancel) || (action.length > 0)) && (
            <div class="a-f-editor-action">
              <el-form-item name="action" label="action" label-width="0">
                {finish && (<el-button class="finish" loading={loading} type="success" on-click={this.finish}>{finishText}</el-button>)}
                {submit && (<el-button class="submit" loading={loading} type="primary" on-click={this.submit}>{submitText}</el-button>)}
                {reject && (<el-button class="reject" loading={loading} type="danger" on-click={this.reject}>{rejectText}</el-button>)}
                {repeal && (<el-button class="repeal" disabled={loading} on-click={this.repeal}>{repealText}</el-button>)}
                {cancel && (
                  <el-button class="cancel" disabled={loading} type={(!finish && !submit && !reject && !repeal) ? 'primary' : 'default'} on-click={this.cancel}>
                    {(!finish && !submit && !reject && !repeal) ? '确定' : cancelText}
                  </el-button>
                )}
                {action.map((a, b) => {
                  const label = a.label || a.title || a.text || a.name || null;
                  if (label) {
                    return (<el-button key={b} disabled={loading} on-click={e => a.click(this.data, this.form, this.option, e)} {...{ attrs: a }}>{label}</el-button>);
                  }
                })}
                {this.$slots.action}
              </el-form-item>
            </div>
          )}
        </el-form>
      </div>
    );
  }
}